import { defaultPlcStatusLogDto, PlcStatusLogDto } from "src/dtos/plcStatusLog/plcStatusLogDto";

export interface EQM1011_R01Dto extends PlcStatusLogDto {
    compCd: string;
    compNm: string;
    plcName: string;
    plcAddressName: string;
}

export const defaultEQM1011_R01Data: EQM1011_R01Dto = {
    ...defaultPlcStatusLogDto,
    compCd: '',
    compNm: '',
    plcName: '',
    plcAddressName: '',
};
